module.exports = __webpack_public_path__ + "static/Will_o_wisp-8862e9e38e3f06cbbfe96b93a7f97142.jpg";